import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import NewsSection from './components/NewsSection';
import InfoBanners from './components/InfoBanners';
import ServicesSection from './components/ServicesSection';
import BlogSection from './components/BlogSection';
import CertificateShowcase from './components/CertificateShowcase';
import AchievementSection from './components/AchievementSection';
import { useSEO } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'IQCERT Sertifika Hizmetleri - İstanbul Belgelendirme ve Denetim | ISO Sertifikasyonu',
    description: 'IQCERT olarak İstanbul\'da ISO 9001, ISO 14001, ISO 45001 belgelendirme hizmetleri sunuyoruz. Kalite yönetimi, çevre yönetimi ve iş güvenliği sertifikasyonu için uzman ekibimizle iletişime geçin.',
    keywords: 'ISO belgelendirme, kalite yönetimi, çevre yönetimi, iş güvenliği, IQCERT, İstanbul sertifikasyon',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'IQCERT',
          url: siteUrl,
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/3143f84cced38ce3ece6675b932547d0.png'
          },
          description: 'Belgelendirme ve denetim hizmetleri sunan profesyonel kuruluş',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Maslak Mahallesi, Büyükdere Caddesi No: 123',
            addressLocality: 'İstanbul',
            addressRegion: 'İstanbul',
            postalCode: '34485',
            addressCountry: 'TR'
          },
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+90-212-345-67-89',
            contactType: 'customer service',
            availableLanguage: ['Turkish', 'English', 'German', 'Arabic']
          },
          sameAs: [
            'https://www.linkedin.com/company/iqcert',
            'https://twitter.com/iqcert',
            'https://www.facebook.com/iqcert'
          ]
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'IQCERT Sertifika Hizmetleri',
          publisher: {
            '@id': `${siteUrl}/#organization`
          },
          inLanguage: ['tr', 'en', 'de', 'ar']
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'IQCERT Sertifika Hizmetleri - İstanbul Belgelendirme ve Denetim',
          isPartOf: {
            '@id': `${siteUrl}/#website`
          },
          about: {
            '@id': `${siteUrl}/#organization`
          },
          description: 'ISO standartlarında belgelendirme ve denetim hizmetleri. Kalite, çevre ve iş güvenliği yönetim sistemleri.'
        }
      ]
    }
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <NewsSection />
        <InfoBanners />
        <CertificateShowcase />
        <ServicesSection />
        <AchievementSection />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
}
